import  { useState, useEffect } from 'react'; 
import { useSelector, useDispatch } from 'react-redux'; 
import CardContainer from '../components/CardContainer'; 
import './Wishlist.css'; 
import { fetchUserWishlist } from '../redux/wishlistActions'; 


const Wishlist = () => { 
    
    const dispatch = useDispatch();
    const wishlistItems = useSelector(state => state.wishlist.items); 
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        
        dispatch(fetchUserWishlist())
            .catch(error => console.error("Failed to load wishlist data:", error))
            .finally(() => setLoading(false));
            
    }, [dispatch]);

    return ( 
        <div className='mt-4'> 
            <CardContainer 
                posts={wishlistItems} 
                loading={loading} 
                title="Wishlist" 
                isWishlistPage={true} 
            /> 
        </div> 
    ); 
}; 

export default Wishlist;